<template>
  <div>
    <TitlePage :title="$t('calendar')+' '+$t('field')+' '+description"></TitlePage>

    <v-layout wrap>
      <v-tabs v-model="tab" background-color="accent" dark>
        <v-tabs-slider color="green"></v-tabs-slider>

          <v-tab href="#tab-1" @click="goToSettings" v-if="getRoleName !== 'Collaboratore'">
            <v-icon small class="mr-2">mdi-hand-coin</v-icon>
            {{ $tc('price', 2) }}
          </v-tab>

          <v-tab href="#tab-2" @click="goToMasterCalendar" v-if="getRoleName !== 'Collaboratore'">
            <v-icon small class="mr-2">mdi-calendar</v-icon>
            {{ $t('masterCalendar') }}
          </v-tab>

          <v-tab href="#tab-3">
            <v-icon small class="mr-2">mdi-calendar</v-icon>
            {{ $t('calendar') }}
          </v-tab>

      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item :value="'tab-1'">

        </v-tab-item>
        <v-tab-item :value="'tab-2'">

        </v-tab-item>
        <v-tab-item :value="'tab-3'">
          <LiveCalendarComponent :selected_field="this.fieldId"></LiveCalendarComponent>
        </v-tab-item>
      </v-tabs-items>
    </v-layout>
  </div>
</template>

<script>
import LiveCalendarComponent from "@/components/admin/LiveCalendar.vue";
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "LiveCalendar",
  components: {TitlePage,LiveCalendarComponent},
  data() {
    return {
      tab: 'tab-3',
      description: '',
      pathSettings: '/fields/settings/' + this.$route.params.id,
      pathMasterCalendar: '/fields/master-calendar/' + this.$route.params.id,
      fieldId: null
    };
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser': 'user/getUser',
      'getRoleName': 'user/getRoleName',
    }),

  },
  async created() {
    this.setLoading(true);
    this.fieldId = this.$route.params.id
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
    }),

    goToSettings() {
      this.$router.push(this.pathSettings)
    },
    goToMasterCalendar() {
      this.$router.push(this.pathMasterCalendar)
    },
  },
  mounted() {

  }
}
</script>

<style scoped>
</style>